<div class="bg-white px-4">
    <div
        class="flex-align-center flex justify-between border-b border-solid border-[#0000001a] dark:border-contrast-yellow"
        *ngIf="isShowHeader">
        <h4
            class="orb-app-light-dark:font-semibold flex-align-center flex gap-2 text-xs font-bold uppercase text-grey-dark dark:filter-yellow"
            [class.normal-case]="env.REMOVE_UPPERCASE">
            {{ 'FAVORITE_JOURNEYS' | translate }}
        </h4>
        <ion-button
            class="var-app-light:text-primary orb-app-light-dark:text-xm my-0 -mr-2 h-12 text-xs font-semibold normal-case text-secondary dark:text-contrast-yellow"
            (click)="handleEditFavorites()"
            fill="clear">
            <ion-label class="text-xs font-semibold normal-case">
                {{ 'EDIT' | translate }}
            </ion-label>
        </ion-button>
    </div>

    <rwidget-journey-planner-location-mark
        class="block border-b border-solid border-[#0000001a] last:border-none dark:border-contrast-yellow"
        *ngFor="let stop of favoriteStopsFormatted"
        [isShowRemoveIcon]="isShowLocationRemoveIcon"
        [location]="stop"
        (clickOnRemoveIcon)="handleRemoveLocations($event)"
        (clickOnLocation)="handleClickOnLocation($event)">
    </rwidget-journey-planner-location-mark>
</div>
